export async function loadContent() {
    if (this.loading) return;

    const direction = this.direction;
    if (!direction) return;
    const nextPage = direction === 'next' ? this.lastLoadedPage + 1 : this.firstLoadedPage - 1;

    if (nextPage < 1 && direction === 'prev') return;

    this.loading = true;

    if (this.loader) {
        this.addLoader();
    }

    const currentUrl = new URL(window.location.href);
    const searchParams = new URLSearchParams(currentUrl.search);
    searchParams.set('page', nextPage);
    
    const url = `${currentUrl.origin}${currentUrl.pathname}?${searchParams.toString()}${currentUrl.hash}`;

    try {
        const response = await fetch(url);

        if (!response.ok) {
            throw new Error('Failed to load content');
        }

        const responseText = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(responseText, 'text/html');

        const newContainer = doc.querySelector(this.settings.container);
        
        if (newContainer) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = newContainer.innerHTML;

            const newElements = tempDiv.querySelectorAll(this.settings.itemCard);
            const nextLoader = this.paginationNextElement;
            const buttonElement = this.buttonElement;
            
            if (!newElements.length && direction === 'next') {
                if (nextLoader) nextLoader.querySelector('a').innerText = `No more items`;
                if (buttonElement) {
                    buttonElement.classList.add('hidden');
                }
                this.loading = false;
                return;
            }
            else {
                if (nextLoader) nextLoader.querySelector('a').innerText = this.settings.loadMoreText;
                if (buttonElement) {
                    const buttonText = buttonElement.querySelector('button');
                    if (buttonText) buttonText.textContent = this.settings.loadMoreText;
                }
            }
            
            newElements.forEach(element => {
                element.setAttribute('data-page', nextPage);
            });

            if (direction === 'next') {
                this.lastLoadedPage = nextPage;
                this.containerElement.insertAdjacentHTML('beforeend', tempDiv.innerHTML);
            } else {
                this.firstLoadedPage = nextPage;
                this.containerElement.insertAdjacentHTML('afterbegin', tempDiv.innerHTML);
            }

            const newlyAddedElements = this.containerElement.querySelectorAll(`${this.settings.itemCard}[data-page="${nextPage}"]`);
            // this.addMouseOverListeners(newlyAddedElements);
            this.updatePageNumberAndHistory(newElements[0]);
            this.loading = false;

            if (this.loader) {
                this.removeLoader();
            }
        }

    } catch (error) {
        console.error(error);
        this.loading = false;
        
        // Restore button text on error
        if (this.buttonElement) {
            const buttonText = this.buttonElement.querySelector('button');
            if (buttonText) buttonText.textContent = this.settings.loadMoreText;
        }
    }
}
